import React from "react";

export default function MerchantPageShell({
  eyebrow,
  title,
  lede,
  children,
  step = null,
  totalSteps = null,
  rightAction,
}) {
  return (
    <section className="public-section merchant-page-shell">
      <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
  }}
>
  {eyebrow ? (
    <div className="merchant-eyebrow-lite">{eyebrow}</div>
  ) : <div />}

  {rightAction ? <div>{rightAction}</div> : null}
</div>

      {typeof step === "number" && typeof totalSteps === "number" ? (
        <div
          style={{
            fontSize: 13,
            color: "rgba(40,40,40,0.6)",
            marginTop: 6,
            marginBottom: 10,
          }}
        >
          Step {step} of {totalSteps}
        </div>
      ) : null}

      {title ? <h1 className="public-h1 merchant-page-title">{title}</h1> : null}
      {lede ? <p className="public-lede merchant-page-lede">{lede}</p> : null}

      <div className="merchant-page-body">{children}</div>
    </section>
  );
}